import { FetchKpiInput } from "@/api/statistics"
import { StatisticLocalPresenceService } from "@/services"
import KpiLocalPresenceStore from "@/store/kpi-local-presence"
import useLocationStore from "@/store/location"
import UiStore from "@/store/ui"
import UserSessionStore from "@/store/user-session"
import { useCallback, useEffect, useMemo, useState } from "react"
import useUiPageSession from "../useUiPageSession"

const useLogic = () => {
    const {
        graph,
        kpi,
        payloadFilter,
        update,
        selectedBusinesses,
        selectedPeriod,
        loading,
        updatePayload,
        updatePeriod,
    } = KpiLocalPresenceStore()
    const [keyWordsList, setKeyWordsList] = useState<any>()
    const { preferredLanguage } = UiStore()
    const { profile } = UserSessionStore()
    const { businesses } = useLocationStore()

    useUiPageSession({
        title: "LOCAL_PRESENCE.TITLE_PERFORMANCE",
        page: "local_presence",
    })

    const handleSelectionChange = useCallback((items) => {
        const filteredLocationIds = items?.map((item) => item.value) || []
        if (filteredLocationIds?.length > 0) {
            update({
                selectedBusinesses: items,
            })
            updatePayload({ locationsId: filteredLocationIds })
        } else {
            updatePayload({ locationsId: [] })
            update({ selectedBusinesses: [] })
        }
    }, [])
    const handleSelectionPeriodChange = useCallback((item) => {
        let type = "year"
        if (item.value === 1) {
            type = "month"
        } else if (item.value === 2) {
            type = "quarter"
        }
        updatePayload({ type: type })
        updatePeriod(item)
    }, [])

    const defaultIds = useMemo(async () => {
        if (businesses) {
            return businesses?.map((data) => String(data.value)) || []
        }
        return []
    }, [businesses])

    const fetchKpi = useCallback(
        async (filterParams: Partial<FetchKpiInput>) => {
            update({ loading: true })

            const ids = payloadFilter.locationsId?.length > 0 ? payloadFilter.locationsId : await defaultIds
            if (ids) {
                const locationsId = filterParams?.locationsId?.length > 0 ? filterParams.locationsId : ids
                const response = await StatisticLocalPresenceService.fetchKpi({
                    ...payloadFilter,
                    ...filterParams,
                    locationsId,
                })
                update({ graph: response?.graph, kpi: response?.kpi })

                if (response?.keywords) {
                    const keyWords = response.keywords.map((item: any, index) => {
                        return {
                            id: index + 1,
                            ...item,
                        }
                    })
                    setKeyWordsList(keyWords)
                }
            }

            update({ loading: false })
        },
        [payloadFilter, defaultIds]
    )

    useEffect(() => {
        fetchKpi({})
    }, [fetchKpi])

    const graphs = useMemo(() => {
        if (graph)
            return {
                views: StatisticLocalPresenceService.resolveGraphsViews(graph, payloadFilter.type, preferredLanguage),
                clicks: StatisticLocalPresenceService.resolveGraphsClicks(graph, payloadFilter.type, preferredLanguage),
                calls: StatisticLocalPresenceService.resolveGraphsCalls(graph, payloadFilter.type, preferredLanguage),
            }
        return {
            views: {},
            clicks: {},
            calls: {},
        }
    }, [graph, payloadFilter.type, preferredLanguage])

    return {
        handleSelectionChange,
        handleSelectionPeriodChange,
        kpi,
        keyWordsList,
        profile,
        graph,
        payloadFilter,
        graphs,
        loading,
        selectedBusinesses,
        selectedPeriod,
        listBusinessToCompare: graph?.details,
    }
}

export default useLogic
